import React, { useState } from 'react';

import './Signup.css';

const Signup = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [email, setEmail] = useState('');
  const [pincode, setPincode] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');

  const handleForm = async (e) => {
    e.preventDefault();
    const response = await fetch('http://localhost:5000/api/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstName: firstName,
        lastName: lastName,
        contactNumber: contactNumber,
        email: email,
        pincode: pincode,
        password: password,
      }),
    });

    const data = await response.json();
    console.log(data);
    console.log(response.status);

    setStatus(response.status);
  };
  return (
    <div className='signup-wrapper'>
      <span>{status}</span>
      <form onSubmit={handleForm} className='signup-form'>
        <div>
          <label htmlFor='firstName'>First Name</label>
          <br />
          <input
            type='text'
            name='firstName'
            value={firstName}
            id='firstName'
            onChange={(e) => {
              setFirstName(e.target.value);
            }}
          />
        </div>
        <div>
          <label htmlFor='lastName'>Last Name</label>
          <br />
          <input
            type='text'
            name='lastName'
            value={lastName}
            id='lastName'
            onChange={(e) => {
              setLastName(e.target.value);
            }}
          />
        </div>
        <div>
          <label htmlFor='contactNumber'>Contact Number</label>
          <br />
          <input
            type='text'
            name='contactNumber'
            value={contactNumber}
            id='contactNumber'
            onChange={(e) => {
              setContactNumber(e.target.value);
            }}
          />
        </div>
        <div>
          <label htmlFor='email'>Email</label>
          <br />
          <input
            type='email'
            name='email'
            value={email}
            id='email'
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <div>
          <label htmlFor='pincode'>Pincode</label>
          <br />
          <input
            type='text'
            name='pincode'
            value={pincode}
            id='pincode'
            onChange={(e) => {
              setPincode(e.target.value);
            }}
          />
        </div>
        <div>
          <label htmlFor='password'>Password</label>
          <br />
          <input
            type='password'
            name='password'
            value={password}
            id='password'
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </div>
        <button className='submit-btn' type='submit'>
          Register
        </button>
      </form>
    </div>
  );
};

export default Signup;
